<template>
  <ProToPlusReactivationModal
    :isOpen="isProToPlusModalOpen"
    :isPriceLoading="isPriceLoading"
    :plusMonthlyPrice="plusMonthlyPrice"
    :annualPrice="annualPrice"
    :proPrice="proPrice"
    :isPricingComparison="isPricingComparison"
    :monthlySavings="monthlySavings"
    @confirm="confirm"
    @cancel="resetModal"
  />
</template>

<script setup>
import ProToPlusReactivationModal from '@/components/billing/premiumProducts/reactivation/ProToPlusReactivationModal.vue'

import appAnalytics from '@/utils/tracking'
import { useProToPlusReactivation } from '@/components/billing/premiumProducts/reactivation/useProToPlusReactivation'
import { useStudioPlusReactivation } from '@/components/billing/premiumProducts/reactivation/useStudioPlusReactivation'
import { useProToPlusPricingData } from '@/components/billing/premiumProducts/reactivation/useProToPlusPricingData'

const { isProToPlusModalOpen, proToPlusAccommodationId, proToPlusSource, closeProToPlusModal } =
  useProToPlusReactivation()
const { openReactivationModal } = useStudioPlusReactivation()

const { isPriceLoading, plusMonthlyPrice, annualPrice, proPrice, isPricingComparison, monthlySavings } =
  useProToPlusPricingData(proToPlusAccommodationId)

const confirm = () => {
  appAnalytics.track(appAnalytics.events.PRO_TO_PLUS_REACTIVATION_CONFIRMED, {
    item_id: proToPlusAccommodationId.value,
    source: proToPlusSource.value,
    is_pricing_comparison: isPricingComparison.value,
    previous_product_type: 'PRO',
  })

  openReactivationModal(proToPlusAccommodationId.value, proToPlusSource.value)
  closeProToPlusModal()
}

const resetModal = () => {
  appAnalytics.track(appAnalytics.events.PRO_TO_PLUS_MODAL_DISMISSED, {
    item_id: proToPlusAccommodationId.value,
    source: proToPlusSource.value,
  })
  closeProToPlusModal()
}
</script>
